import { LogisticAddress } from './address.model';
import { PickUpInformation } from './pickup-information.model';

export class ShipFrom {
  accountCode: string;
  company: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  pickUpInformation: PickUpInformation;
  address: LogisticAddress;
  shipmentDate: Date;
}
